<template>
  <div class="imageMap-layout">
    <template v-if="isSplashscreen">
      <div
        ref="splashscreen-home-container"
        class="splashscreen-home"
        v-html="html"
      />
      <div
        id="accessSplash"
        :class="showAccess"
        style="height: 65px;"
      >
        <button
          class="btn btn-accept btn-secondary button-splashscreen__access"
          @click="showHome()"
        >
          Access
        </button>
      </div>
    </template>
    <template v-else>
      <div
        :id="`${resource}-container`"
        :ref="`${resource}-container`"
        :class="`imagemap-width`"
        v-html="html"
      />
    </template>
    <modal
      :show="videoModal.show"
      class="image-map__video-modal"
      @close="videoModal.show = false"
    >
      <video-player
        :options="videoOptions"
        class="embed-responsive"
      />
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import utils from '../utilities'
import trackingApi from '~/api/tracking'
import Modal from './../Modal/index.vue'
import VideoPlayer from '~/components/industryLandingPage/videoPlayer.vue'

export default {
  name: 'ImageMap',
  data() {
    return {
      showAccess: null,
      videoModal: {
        show: false,
      },
      videoOptions: {
        autoplay: true,
        controls: true,
        fluid: true,
        sources: [
          {
            src: null,
            type: 'video/mp4',
          },
        ],
      },
    }
  },
  components: {
    Modal,
    VideoPlayer,
  },
  props: {
    isSplashscreen: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: String,
      default: '',
    },
  },
  created() {
    if (this.isSplashscreen) {
      window.showHome = () => {
        if (this.showVenuePage) {
          localStorage.setItem('hasSeenSplashscreen', 'true')
          window.location.href = this.accessButtonRedirect
        } else {
          utils.showHome()
          this.rerender()
        }
      }
      if (localStorage.getItem('hasSeenSplashscreen')) {
        window.setImageMapHeader()
      }
      if (this.$t('VMX.home_splash_screen') && this.$t('VMX.home_splash_screen').startsWith('<') && !localStorage.getItem('hasSeenSplashscreen')) {
        document.getElementById('app').classList.add('hasSplashscreen')
        this.showAccess = 'showAccess'
      }
      window.playSplashVideo = (url, entitiyId, sourceContext) => {
        this.showVideo(url, entitiyId, sourceContext)
      }
    }
    window.playVideo = (url, entitiyId, sourceContext) => {
      this.showVideo(url, entitiyId, sourceContext)
    }
  },
  mounted() {
    if (!this.isSplashscreen && this.$refs[`${this.resource}-container`]) {
      const container = this.$refs[`${this.resource}-container`]
      if (container.querySelector('img')) {
        container.querySelector('img').setAttribute('usemap', `#image-map-${this.resource}`)
        if (container.querySelector('img').id === 'panzoom') {
          window.loadPanZoomImageMap()
        }
      }
      container.querySelector('map').name = `image-map-${this.resource}`
      window.setImageMapMapping(`#${this.resource}-container map`)
    } else {
      const container = this.$refs['splashscreen-home-container']
      if (container.childNodes.length > 0) {
        container.querySelector('img').setAttribute('usemap', '#image-map-splashscreen')
        if (container.querySelector('map')) {
          container.querySelector('map').id = 'imagemapSplashscreen'
          container.querySelector('map').name = 'image-map-splashscreen'
        }
      }
      window.setImageMapSplashscreen()
    }
  },
  computed: {
    ...mapGetters({
      event: 'instancesState/getEvent',
      instance: 'instancesState/getInstance',
      language: 'instancesState/getLanguage',
      getConfigForKey: 'config/configForKey',
    }),
    html() {
      if (this.isSplashscreen) {
        if (this.$t('VMX.home_splash_screen') && this.$t('VMX.home_splash_screen').startsWith('<')) {
          return this.$t('VMX.home_splash_screen')
        }
      } else if (this.$t(`VMX.${this.resource}`) && this.$t(`VMX.${this.resource}`).startsWith('<')) {
        return this.$t(`VMX.${this.resource}`)
      }
      return null
    },
    showVenuePage() {
      const config = this.getConfigForKey('app_config').config[0]
      if (config.defaults.showVenuePage) {
        return config.defaults.showVenuePage
      }
      return false
    },
    accessButtonRedirect() {
      const config = this.getConfigForKey('app_config').config[0]
      const redirect = config.defaults.splashScreenButton
      if (redirect) {
        return redirect
      }
      return `${window.location.origin}/home/${this.instance}/${this.event}/${this.language}`
    }
  },
  methods: {
    rerender() {
      this.$emit('rerender')
    },
    showHome() {
      if (this.showVenuePage) {
        localStorage.setItem('hasSeenSplashscreen', 'true')
        window.location.href = this.accessButtonRedirect
      } else {
        utils.showHome()
        this.rerender()
      }
    },
    async windowActionTracking(sourceContentAction, entityId, sourceContext) {
      if (sourceContentAction && sourceContext) {
        await trackingApi.trackCustomAction(sourceContentAction, entityId, sourceContext)
      }
    },
    showVideo(url, entityId, sourceContext) {
      this.videoOptions.sources[0].src = url
      this.videoModal.show = true
      this.trackingVideo(entityId, sourceContext)
    },
    async trackingVideo(entitiyId, sourceContext) {
      if (sourceContext) {
        await trackingApi.trackCustomAction('vmx-imageMap-video', entitiyId, sourceContext)
      }
    },
  },
}
</script>

<style lang="scss">
#accessSplash {
  display: none;

  .button-splashscreen__access {
    display: none;
    background-color: var(--header-navbar-bg);
    border-color: var(--header-navbar-bg);
  }
}

.hasSplashscreen {
  .mb-2 {
    display: none;
  }

  area {
    cursor: pointer;
  }

  .splashscreen-home img {
    width: 100%;
    height: auto;
    position: relative;

    left: 0;
    display: block;
    top: 0;
  }

  #accessSplash {
    display: block;

    &.showAccess .button-splashscreen__access {
      position: relative;
      top: 15px;
      margin: 0 auto;
      display: block;
    }
  }

  .component-grid {
    display: none;
  }

  header {
    display: none;
  }

  .page-footer {
    display: none;
  }

  .ntw-sidebar {
    display: none;
  }

  .networking-padding-right {
    padding-right: 0;
  }

  .networking-padding-bottom {
    padding-bottom: 0;
  }

  .ntw-sidebar-wrapper {
    height: 0;
  }

  .ntw-modal-wrapper {
    visibility: hidden;
  }
}

.asia2020.hasSplashscreen {
  .page-content {
    background-color: #fff !important;
  }

  .mb-2 {
    display: none;
  }

  area {
    cursor: pointer;
  }

  .splashscreen-home img {
    width: 100%;
    height: auto;
    position: relative;

    left: 0;
    display: block;
    top: 0;
  }

  #accessSplash {
    display: block !important;
    background-color: #ccc;

    &.showAccess .button-splashscreen__access {
      position: relative;
      top: 15px;
      margin: 0 auto;
      display: block !important;
    }
  }

  .component-grid {
    display: none;
  }

  header {
    display: none;
  }

  .page-footer {
    display: none;
  }
}

.imagemap-width img {
  width: 100%;
}

area {
  outline: 0;
}
</style>
